<template>
  <v-radio-group v-model="radioGroup">
    <v-container fluid style="height: 100%;padding:0 ">
      <v-col class="pa-0 pa-sm-10">
        <v-container fluid>
          <v-row justify="center">
            <v-col class="pa-2 pa-sm-10" align="center" style="display: flex; flex-direction: column; align-content: center; justify-content: center;">
              <span v-if="invoices.length!==0 && originalInvoice.receiverCif===$user.cif"> {{ $t('ListInvoicesForCompensate.Candidate invoice for the Forward:') }} </span>
              <span v-else-if="invoices.length!==0 && originalInvoice.payerCif===$user.cif"> {{ $t('Candidate invoice for the Byppay:') }} </span>
              <span v-else> {{ $t('You not have Candidates!') }} </span>
              <v-simple-table v-if="invoices.length!==0" style="margin-top: 20px; width: 100%">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        {{ $t('Participant') }}
                      </th>
                      <th class="text-left">
                        {{ $t('Amount') }}
                      </th>
                      <th class="text-left" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoices" :key="item.invoice._id" style="padding:0">
                      <td>{{ getNameFromUser(item.invoice) }}</td>
                      <td>{{ item.invoice.outstandingAmmount }} €</td>
                      <td><v-radio @change="changeInvoice(item)" /></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn x-large style="margin: 20px auto; width: fit-content;" class="btn-primary" dark @click="goUploadInvoice">
                {{ $t('Upload Candidate') }}
              </v-btn>
              <v-container v-if="selected" fluid>
                <v-row justify="center">
                  <v-btn dark x-large style="padding: 15px 75px;" class="justify-center btn-primary" @click="select">
                    {{ $t('GO') }}
                  </v-btn>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-row v-if="showBackButton" justify="center">
        <v-btn x-large style="margin-top: 15px" @click="$router.go(-1)">
          <v-icon style="margin-right: 5px">
            mdi-undo-variant
          </v-icon>{{ $t('Back') }}
        </v-btn>
      </v-row>
    </v-container>
  </v-radio-group>
</template>


<script>
import ApiRepository from "../repositories/ApiRepository";
import {User} from "@/models/user";
import Vue from "vue";

export default {
    name: "ListInvoicesForCompensate",
    props: {
        originalInvoice: {
            type: Object,
            default: null
        },
        byppay: {
            type: Boolean,
            default: false
        },
        showBackButton: {
            type: Boolean,
            default: true
        },
        chatId: {
            type: String,
            default: ""
        },
        createdInvoice: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            invoices: null,
            loading: true,
            providerContact: null,
            invoiceInoMiss: null,
            selected: false,
            sent: true,
            bypay: false,
            file: null,
            actInvoice: null,
            radioGroup: null,
            invoice: {
                amount: 0
            },
            rules: {
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
            },
            mailTo: ""
        };
    },
    async created () {
        await this.fetch();
    },
    methods: {
        async fetch () {
            this.invoices = [];
            let getInvoices = [];
            if (this.originalInvoice.receiver && this.originalInvoice.receiver._id) {
                this.sent = this.originalInvoice.receiver._id.toString() !== this.$user._id.toString();
            } else if (this.originalInvoice.receiver) {
                this.sent = this.originalInvoice.receiver.toString() !== this.$user._id.toString();
            }
            await ApiRepository.listInvoices(this.sent, !this.sent, false)
                .then((res) => {
                    getInvoices = res.data.invoices;
                    this.checkboxes = Array(getInvoices.length).fill(false);
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error accepting petition'), color: 'error'});
                    console.error(err);
                });
            await ApiRepository.archivedInvoices(this.$user.cif)
                .then((res) => {
                    const archivedInvoices = res.data.archivedInvoices;
                    for (const archived of archivedInvoices) {
                        getInvoices = getInvoices.filter(invoice => invoice.invoice._id !== archived);
                    }
                    this.invoices = getInvoices;
                });
        },
        changeInvoice (item) {
            if (!this.actInvoice) {
                this.actInvoice = item.invoice;
                this.file = item.file;
                this.selected = true;
            } else if (this.actInvoice._id === item.invoice._id) {
                this.selected = false;
                this.file = null;
                this.actInvoice = null;
                this.file = null;
            } else {
                this.actInvoice = item.invoice;
                this.file = item.file;
                this.selected = true;
            }
        },
        goUploadInvoice () {
            this.$router.push({name: 'imageInvoice', params: {idInvoice: this.originalInvoice._id, chatId: this.chatId}});
        },
        getNameFromUser (item) {
            let user;
            if (this.$user) item.payerCif !== this.$user.cif ? user = item.payer : user = item.receiver;
            if ( user ) {
                const userModel = new User(user);
                return userModel.getName();
            } else {
                return "Unknown";
            }
        },
        select () {
            this.$emit("save", {invoice: this.actInvoice, file: this.file});
            this.$emit("update", {});
        }
    }
};
</script>

<style scoped>

</style>
